import { render, staticRenderFns } from "./MyRecords.vue?vue&type=template&id=164bb9ab&"
import script from "./MyRecords.vue?vue&type=script&lang=js&"
export * from "./MyRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports